import { trackInp } from './lib/common'
trackInp('ideamans', 10)
